import styles from './PedidoPDF.module.scss';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import DadosDoComprador from '../ComponentesDoPDF/DadosComprador';
import CabecalhoPDF from '../ComponentesDoPDF/CabecalhoPDF';
import DadosDoFornecedor from '../ComponentesDoPDF/DadosDoFornecedor';
import DadosItensPedido from '../ComponentesDoPDF/DadosItensPedido';
import { IPedido } from '../../interfaces/pedido.interface';
import useFetchItensPedido from '../../hooks/itemPedido/useFetchItensPedido';
import { useEffect, useState } from 'react';
import { IitemPedido } from '../../interfaces/itemPedido';
import DatasDePagamento from '../ComponentesDoPDF/DatasDePagamento';
import Botao from '../Botao';

interface Props {
  pedido: IPedido;
  voltar: () => void;
}

async function generateHTMLToPDF() {
  const input = document.getElementById('pdf-content');
  if (!input) return;

  const canvas = await html2canvas(input);
  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF('p', 'mm', 'a4');
  const imgProps = pdf.getImageProperties(imgData);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  pdf.save('pedido-compra.pdf');
}

const PedidoDeCompra = ({ pedido, voltar }: Props) => {
  const { itens } = useFetchItensPedido();
  const [itensDoPedido, setItensDoPedido] = useState<IitemPedido[]>([]);

  useEffect(() => {
    setItensDoPedido(itens.filter(item => item.pedidoId === pedido.id));
  }, [itens]);

  return (
    <div className={styles.container}>
      <div id="pdf-content">
        <CabecalhoPDF />

        <DadosDoComprador pedido={pedido}/>

        <DadosDoFornecedor />

        <DadosItensPedido itens={itensDoPedido} pedido={pedido}/>

        <DatasDePagamento pedido={pedido} />
      </div>

      <div className={styles.btns}>
        <Botao text={'imprimir'} onClick={generateHTMLToPDF}/>
        <Botao text={'voltar'} onClick={voltar}/>  
      </div>
    </div>
  );
};

export default PedidoDeCompra;

